import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';
import { FieldProps } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';

const NextReviewDateField = ({ label, source = '', isVisible }: FieldProps) => {
  const data = useShowContext()?.data;
  const value = data.getValueBySource(source) || '';

  return isVisible ? (
    <Box display="flex" mb="9px">
      <Typography variant="subtitle1" flexShrink={0} mr="5px !important">
        {label as string}
      </Typography>
      {value ? (
        <ShowDate dateUTC={value} format={DATE_FORMAT.NATURAL} isDateTime={false} />
      ) : (
        <Typography variant="body1">Not defined</Typography>
      )}
    </Box>
  ) : null;
};

export default NextReviewDateField;
